module.exports = __webpack_public_path__ + "static/media/Banner_Desktop2x.381ffa53.jpg";